var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstAidKit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.833 8H5.83301C5.28072 8 4.83301 8.44772 4.83301 9V25C4.83301 25.5523 5.28072 26 5.83301 26H27.833C28.3853 26 28.833 25.5523 28.833 25V9C28.833 8.44772 28.3853 8 27.833 8Z",
    fill: "#E85D04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.833 8H5.83301C5.28072 8 4.83301 8.44772 4.83301 9V25C4.83301 25.5523 5.28072 26 5.83301 26H27.833C28.3853 26 28.833 25.5523 28.833 25V9C28.833 8.44772 28.3853 8 27.833 8Z",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.833 8V6C21.833 5.46957 21.6223 4.96086 21.2472 4.58579C20.8721 4.21071 20.3634 4 19.833 4H13.833C13.3026 4 12.7939 4.21071 12.4188 4.58579C12.0437 4.96086 11.833 5.46957 11.833 6V8",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.833 14V20",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.833 17H13.833",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstAidKit);
export default __webpack_public_path__ + "static/media/FirstAidKit.45e85523bc51fc7cfd3f6cdcec9f6e0d.svg";
export { ForwardRef as ReactComponent };